import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import GaussianBellCurve from './GaussianBellCurve';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '12px',
};

export default function AreaDetailModal({ open, handleClose, areaName, distribution }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="area-detail-modal-title"
      aria-describedby="area-detail-modal-description"
    >
      <Box sx={style}>
        <Typography id="area-detail-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
          Distribución de Puntajes Calibrados para Área: {areaName}
        </Typography>
        {distribution && Object.keys(distribution).length > 0 ? (
          <GaussianBellCurve distribution={distribution} />
        ) : (
          <Typography variant="body2" color="text.secondary">No hay datos de distribución de puntaje para esta área.</Typography>
        )}
        <Button onClick={handleClose} variant="contained" sx={{ mt: 3 }}>Cerrar</Button>
      </Box>
    </Modal>
  );
} 